// extracted by mini-css-extract-plugin
module.exports = {"divider":"ChangeCardDialogStyle_divider__eVVEt","otherCardText":"ChangeCardDialogStyle_otherCardText__WQENl"};